<template>
	<div class="container">
		<!--页面开始-->
		<div class="result">
			<!--C清晰T清晰-->
			<div v-if="resultType === 1" class="res_box">
				<div class="top_tip">
					Debe interpretarse como un resultado positivo siempre y cuando la línea T sea visible, sin importar lo tenue que sea.
				</div>
				<div style="padding: 0.6rem;">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/spain/img_ct.webp')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<!--写文字-->
				<div class="step_box">
					<ul>
						<li>El resultado de la prueba debe evaluarse junto con otros datos clínicos disponibles para el médico.</li>
						<li>Los resultados positivos de la prueba no descartan coinfecciones con otros patógenos.</li>
						<li class="mouse_hover" @click="testbook">Consulte las <span class="col_blue">instrucciones</span> de uso para obtener más información.</li>
					</ul>
				</div>
				<!--写文字-->
			</div>
			<!--C清晰T清晰-->
			<!--C清晰T没有-->
			<div v-if="resultType === 2" class="res_box">
				<div style="padding: 0.6rem;">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/spain/img_c_not.webp')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<!--写文字-->
				<div class="step_box">
					<ul>
						<li>El resultado negativo debe tratarse como presuntivo y confirmarse con una prueba molecular autorizada por la FDA.</li>
						<li>Es más probable que las pruebas en serie (es decir, las pruebas todos los días o cada dos días) detecten COVID-19, especialmente cuando no tiene ningún síntoma.</li>
						<li class="mouse_hover" @click="testbook">Consulte las <span class="col_blue">instrucciones</span> de uso para obtener más información.</li>
					</ul>
				</div>
				<!--写文字-->
			</div>
			<!--C清晰T没有-->
			<!--C没有T清晰-->
			<div v-if="resultType === 3" class="res_box">
				<div style="padding: 0.6rem;">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/spain/img_cno_t.webp')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<!--写文字-->
				<div class="step_box">
					<ul>
						<li>Se recomienda revisar las instrucciones nuevamente y repetir la prueba con una nueva muestra y un nuevo casete.</li>
						<li>Si el problema persiste, deje de usar el producto y póngase en contacto con nosotros para obtener asistencia técnica.</li>
						<li class="mouse_hover" @click="testbook">Consulte las <span class="col_blue">instrucciones</span> de uso para obtener más información.</li>
					</ul>
				</div>
				<!--写文字-->
			</div>
			<!--C没有T清晰-->
			<!--C没有T没有-->
			<div v-if="resultType === 4" class="res_box">
				<div style="padding: 0.6rem;">
					<van-image
					  width="100%"
					  height="auto"
					  lazy-load
					  show-loading
					  :src="require('@/assets/img/spain/img_cno_tno.webp')"
					>
						<template v-slot:loading>
							<div class="wrap color-A">
								<div class="k-line k-lineA-1"></div>
								<div class="k-line k-lineA-2"></div>
								<div class="k-line k-lineA-3"></div>
								<div class="k-line k-lineA-4"></div>
							</div>
						</template>
					</van-image>
				</div>
				<!--写文字-->
				<div class="step_box">
					<ul>
						<li>Se recomienda revisar las instrucciones nuevamente y repetir la prueba con una nueva muestra y un nuevo casete.</li>
						<li>Si el problema persiste, deje de usar el producto y póngase en contacto con nosotros para obtener asistencia técnica.</li>
						<li class="mouse_hover" @click="testbook">Consulte las <span class="col_blue">instrucciones</span> de uso para obtener más información.</li>
					</ul>
				</div>
				<!--写文字-->
			</div>
			<!--C没有T没有-->
		</div>
		<!--页面开始-->
		<div class="btn_box">
			<van-button
				type="primary"
				block
				round
				color="linear-gradient(to right, #a74af2, #5949f2)"
				@click="goDelete"
			>
				Finalizar
			</van-button>
		</div>
	</div>
</template>

<script>
export default {
	components:{
		//
	},
	data() {
		return {
			resultType: null,
		}
	},
	created(){
		this.$toast.loading({
			duration: 0,
		});
		if(this.$route.query.cline === 'Yes' && this.$route.query.tline === 'Yes'){
			//阳性
			this.resultType = 1;
		}else if(this.$route.query.cline === 'Yes' && this.$route.query.tline === 'No'){
			//阴性
			this.resultType = 2;
		}else if(this.$route.query.cline === 'No' && this.$route.query.tline === 'Yes'){
			//无效
			this.resultType = 3;
		}else if(this.$route.query.cline === 'No' && this.$route.query.tline === 'No'){
			//无效
			this.resultType = 4;
		}else{
			this.$router.push({path: '/spain/stepOne'});
		}
	},
	mounted() {
		this.$toast.clear();
	},
	watch: {
		//
	},
	methods: {
		//进入检测第一步
		goDelete() {
			sessionStorage.clear();
			//this.$router.push({path: '/spain/stepOne'});
			this.$router.push({path: '/scanqrcode'});
		},
		//进入说明书
		testbook() {
			this.$router.push({path: '/spain/stepNight'});
		},
	},
	destroyed() {
		//
	}
}
</script>
</script>

<style scoped>
.result{
	padding-top: 1rem;
}
.top_tip{
	margin: 0rem 0.9rem 0 0.9rem;
	padding: 0.25rem 0.45rem;
	background-color: #ffcaca;
	font-size: 0.32rem;
	color: #720000;
	border-radius: 8px;
	border: 1px #720000 solid;
	font-weight: bold;
}
.res_box img{
	width: 100%;
}
.res_box .tit_box{
	padding: 0.2rem 1.2rem 0 0.8rem;
}
.book_box{
	padding: 0.4rem 1.2rem 0 0.8rem;
}
.btn_box{
	position: fixed;
	bottom: 0.667rem;
	width: 100%;
	padding: 0 0.9rem 0 0.9rem;
}
.btn_box img{
	width: 100%;
}
.col_blue{
	color: rgb(0, 120, 255);
}

.step_box{
	padding: 0.1rem 1rem;
}
.step_box ul li{
	padding: 0.18rem 0 0.18rem 0;
	font-size: 0.427rem;
}
.step_box ul li span{
	font-size: 0.427rem;
}
.step_box .mouse_hover{
	cursor: pointer;
}

>>> .van-button{height: 1.2rem;}
>>> .van-button__text{color: #ffffff;font-size: 0.48rem;font-weight: bold;}

@media only screen 
and (device-width : 375px) 
and (device-height : 667px) 
and (-webkit-device-pixel-ratio : 2) {
   .btn_box{
	   position: relative;
	   padding: 1.5rem 0.9rem 0.667rem 0.9rem;
   }
}
@media screen and (min-device-width : 768px){
	.btn_box{
		position: relative;
		width: 100%;
		padding: 3rem 0.9rem 0 0.9rem;
	}
} 
</style>
